export type UartMessage = {
    id: number;
    message: string;
    type: string;
    time: string;
};

export type DebugState = {
    uartMessageList: UartMessage[];
};

export const initialDebugState: DebugState = {
    uartMessageList: [],
};
